<template>
    <div>
        <input 
            type="radio" 
            :name="auspraegung.name" 
            :value="identifier" 
            :id="identifier"
            :checked="isCurrentSelection()"
            v-on:change="$emit('input', $event.target.value)">

        <label :for="identifier" class="label-aligned font-weight-bold">
            <span class="mainlabel">{{auspraegung.name}}</span>
            <span class="font-weight-light d-block@until-large text-small@until-medium">{{getPostage()}}</span>
            <Tooltip v-if="tooltip" :infoText="tooltip"/>
        </label>
        <template v-if="getSubtype() == SUBTYPE_VERSANDAUFTEILUNG && isCurrentSelection()">
            <VersandaufteilungOverlay 
                :isCheckout="false"
                :auspraegungen="option.auspraegungen"
            >
            </VersandaufteilungOverlay>
        </template>
    </div>
</template>
<script>
    import Tooltip from "./Tooltip";
    import VersandaufteilungOverlay from "./versandaufteilung/VersandaufteilungOverlay";

    const SUBTYPE_VERSANDAUFTEILUNG = "Versandaufteilung";

    export default {
        components: {Tooltip, VersandaufteilungOverlay},
        props: ["identifier", "option", "auspraegung", "current"],
        inject: ['configuratorService'],
        data() {
            return {
                SUBTYPE_VERSANDAUFTEILUNG: SUBTYPE_VERSANDAUFTEILUNG
            }
        },
        mounted() {
            console.log("is mounted", this.option)
        },
        methods: {
            getPostage() {
                return this.option.customValues[this.auspraegung.id]?.postage
            },
            getSubtype() {
                return this.option.customValues[this.auspraegung.id]?.subtype
            },
            isCurrentSelection() {
                return this.identifier == this.current
            },
        },
        computed: {
            tooltip: function () {
                return this.option.customValues[this.auspraegung.id]?.tooltip
            },
        },
    };
</script>
